import React, { Component } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import '../css/projects.css';
import ProjectsCard from './ProjectsCard';

class Projects extends Component {
    static contextType = LanguageContext;
    
    state = {
        projects: [],
        loading: true,
        error: null
    };

    componentDidMount() {
        this.loadProjects();
    }

    loadProjects = () => {
        fetch('/data/projects.json')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                const projectsArray = Object.values(data);
                this.setState({ 
                    projects: projectsArray, 
                    loading: false,
                    error: null 
                });
            })
            .catch(error => {
                console.error("Fehler beim Laden der Projekte:", error);
                this.setState({ 
                    loading: false, 
                    error: error.message 
                });
            });
    };

    // Funktion zum Rendern der detaillierten Beschreibung als JSX
    renderDetailedDescription = (project, language) => {
        const langKey = language.toLowerCase();
        const detailedDesc = project.detailed_desc?.[langKey] || project.detailed_desc?.en;
        
        if (!detailedDesc) {
            return <p><em>No detailed description available</em></p>;
        }

        // Falls es ein String ist (für Rückwärtskompatibilität)
        if (typeof detailedDesc === 'string') {
            return <p><em>{detailedDesc}</em></p>;
        }

        // Falls es ein Objekt mit strukturierten Daten ist
        return (
            <>
                <p><em>{detailedDesc.description}</em></p>
                <br />
                
                {detailedDesc.technologies && (
                    <>
                        <p><strong>{detailedDesc.technologies_title}</strong> {detailedDesc.technologies}</p>
                        <br />
                    </>
                )}
                
                {detailedDesc.features && detailedDesc.features.length > 0 && (
                    <>
                        <ul>
                            {detailedDesc.features.map((feature, index) => (
                                <li key={index}>{feature}</li>
                            ))}
                        </ul>
                        <br />
                    </>
                )}
                
                {project.links?.map((link, i) => (
                    <React.Fragment key={i}>
                        <a href={link.url} target="_blank" rel="noreferrer">
                            <i className="ph ph-link"></i> {link.label}
                        </a>
                        <br />
                    </React.Fragment>
                ))}
            </>
        );
    };

    render() {
        const { translations, language } = this.context;
        const { projects, loading, error } = this.state;

        if (loading) {
            return (
                <section id="projects">
                    <div className='projects-container'>
                        <div className="loading">Loading projects...</div>
                    </div>
                </section>
            );
        }

        if (error) {
            return (
                <section id="projects">
                    <div className='projects-container'>
                        <div className="error">
                            Error loading projects: {error}
                            <button onClick={this.loadProjects} className="retry-button">
                                Retry
                            </button>
                        </div>
                    </div>
                </section>
            );
        }

        return (
            <section id="projects">
                <div className='projects-container'>
                    <h1 className='projects-title'>
                        {translations?.projects_page_title || 'Projects'}
                    </h1>
                    <p className='pageDescription'>
                        {translations?.projects_page_description || 'My projects'}
                    </p>
                    <div className='projects-wrapper'>
                        {projects.length > 0 ? (
                            projects.map((project, index) => (
                                <ProjectsCard
                                    key={project.id || index}
                                    projectTitle={
                                        project.title?.[language.toLowerCase()] || 
                                        project.title?.en || 
                                        'Untitled Project'
                                    }
                                    projectDescription={
                                        project.short_desc?.[language.toLowerCase()] || 
                                        project.short_desc?.en || 
                                        'No description available'
                                    }
                                    imageURL={project.img_url || ''}
                                    imagePosition={index % 2 === 0 ? 'right' : 'left'}
                                    projectTag={
                                        project.tag?.[language.toLowerCase()] || 
                                        project.tag?.en || 
                                        'no tag available'
                                    }
                                    projectMoreInfo={this.renderDetailedDescription(project, language)}
                                />
                            ))
                        ) : (
                            <div className="no-projects">
                                {translations?.no_projects_available || 'No projects available'}
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}

export default Projects;